
import "@babel/polyfill";
import objectFitImages from 'object-fit-images';
import * as Scroll from './utils/scroll.js';
import * as Cookie from './utils/cookies.js';
import * as Is from './utils/is.js';
import * as Breakpoint from './utils/breakpoints.js';
import 'lazysizes';
import 'lity';

import './dialog';
import './materials';


//* scroll listener =================================================== */

var lastScrollTop = 0;
var lastScrollUp = 0;
function handleScroll() {

  // var scrollY = window.scrollY;
  var scrollY = window.pageYOffset || document.documentElement.scrollTop;
  var direction = 'down';
  if (scrollY > lastScrollTop){
    direction = 'down';
  } else {
    direction = 'up';
  }
  lastScrollTop = scrollY <= 0 ? 0 : scrollY; // For Mobile or negative scrolling

  if (direction == 'up') {
    lastScrollUp = scrollY;
  }


  if (scrollY > 0) {
    document.querySelector('body').classList.add('s_sticky');
  } else {
    document.querySelector('body').classList.remove('s_sticky');
  }

  if (document.querySelector('.mega')) {
    if (scrollY > 300 && direction == 'down' && scrollY >= (lastScrollUp + 300)) {
      document.querySelector('.mega').classList.add('s_sleeping');
    } else {
      document.querySelector('.mega').classList.remove('s_sleeping');
    }
  }

}

window.addEventListener('scroll', handleScroll);
handleScroll();


//* array remove =================================================== */

Array.prototype.remove = function() {
    var what, a = arguments, L = a.length, ax;
    while (L && this.length) {
        what = a[--L];
        while ((ax = this.indexOf(what)) !== -1) {
            this.splice(ax, 1);
        }
    }
    return this;
};


//* objectfit polyfill =================================================== */

objectFitImages();


//* listener =================================================== */

function listenTo(query, act, callback) {
  var items = document.querySelectorAll(query);
  for (let i = 0; i < items.length; i++) {
    items[i].addEventListener(act, callback);
  }
}


//* nav =================================================== */

function navToggle() {
  document.querySelector('body').classList.toggle('s_nav');
}

if (document.querySelector('[data-action="navToggle"]')) {
  document.querySelector('[data-action="navToggle"]').addEventListener('click', navToggle);
}

function navOpen() {
  this.parentElement.classList.toggle('s_active');
  event.preventDefault();
  return false;
}

listenTo('[data-action="navOpen"]', 'click', navOpen);


// //* hero slider =================================================== */

// var slideCurrent = 1;
// var slideTotal = 3;
// var slideSpeed = 4000;
// var slideInterval;

// function sliderSwitch() {

//   $('.hero-slide').removeClass('s_active');
//   $('.hero-slide[data-id="' + slideCurrent + '"]').addClass('s_active');

//   $('.hero-dot').removeClass('s_active');
//   $('.hero-dot[data-id="' + slideCurrent + '"]').addClass('s_active');

//   $('.hero-image').removeClass('s_active');
//   $('.hero-image[data-id="' + slideCurrent + '"]').addClass('s_active');

// }

// function sliderNext() {
//   slideCurrent ++;
//   if (slideCurrent > slideTotal) {
//     slideCurrent = 1;
//   }
//   sliderSwitch();
// }

// function sliderSet(slideNum) {
//   slideCurrent = slideNum;
//   sliderSwitch();
//   clearInterval(slideInterval);
//   sliderStart();
// }

// function sliderStart() {
//   slideInterval = setInterval(function(){ sliderNext() }, slideSpeed);
// }

// $(document).on('click','.hero-dot',function(){
//   var dataId = $(this).attr('data-id');
//   sliderSet(dataId);
//   return false;
// });

// sliderStart();


//* mega menu =================================================== */

var menu_timeout;

function navLinkMouseEnter(obj) {
  var $this = obj;
  $('.nav .nav-link').removeClass('s_hover');
  $this.addClass('s_hover');
  var class_name = $this.attr('href').toLowerCase().replace(/\/$/, '');
  class_name = class_name.substr(class_name.lastIndexOf('/') + 1);
  // console.log(class_name);
  if ($('.mega-nav[data-id="' + class_name + '"]').length) {

    // if (!$('.mega').hasClass('s_' + class_name)) {
    //   $('.mega').removeClass (function (index, css) {
    //     return (css.match (/s_\S+/g) || []).join(' ');
    //   });
    // }

    if ($('.mega').hasClass('s_static')) {
      $('.mega-nav[data-id="' + $('.mega').attr('data-static') + '"]').removeClass('s_active');
    }

    if (!$('.mega-nav[data-id="' + class_name + '"]').hasClass('s_active')) {
      $('.mega-nav').removeClass('s_active');
      $('.mega-nav[data-id="' + class_name + '"]').addClass('s_active');
    }

    $('.header').addClass('s_active');
    $('.mega').addClass('s_active');
    $('.mega').removeClass('s_sleeping');
    lastScrollUp = window.pageYOffset || document.documentElement.scrollTop;

  } else {

    $('.header').removeClass('s_active');
    $('.mega').removeClass('s_active');

    megaStaticRestore();

    // if ($('.mega').hasClass('s_static')) {
    //   $('.mega').removeClass (function (index, css) {
    //     return (css.match (/s_\S+/g) || []).join(' ');
    //   });
    //   $('.mega').addClass('s_' + $('.mega').attr('data-static'));
    // }
  }
}

$(document).on('click touchend','.nav a.nav-link',function(event){
  if (Is.touch) {
    var $this = $(this);
    clearTimeout(menu_timeout);
    menu_timeout = setTimeout(function(){navLinkMouseEnter($this)}, 100);
    var class_name = $this.attr('href').toLowerCase().replace(/\/$/, '');
    class_name = class_name.substr(class_name.lastIndexOf('/') + 1);
    if ($('[data-id="' + class_name + '"]').length) {
      event.stopPropagation();
      event.preventDefault();
      return false;
    }
  } else {
    return true;
  }
});

$(document).on('mouseenter','.nav a.nav-link',function(event){
  var $this = $(this);
  clearTimeout(menu_timeout);
  menu_timeout = setTimeout(function(){navLinkMouseEnter($this)}, 100);
});

function navLinkMouseLeave(obj) {
  var $this = obj;
  var class_name = $this.attr('href').toLowerCase().replace(/\/$/, '');
  class_name = class_name.substr(class_name.lastIndexOf('/') + 1);
  if (!$('.mega').hasClass('s_active')) {

    $('.mega').removeClass('s_active');
    $('.mega-nav').removeClass('s_active');
    $this.removeClass('s_hover');

    if ($('.mega').hasClass('s_static')) {
      $('.mega-nav').removeClass('s_active');
      $('.mega-nav[data-id="' + $('.mega').attr('data-static') + '"]').addClass('s_active');
    }
  }
}

$(document).on('mouseleave','.nav a.nav-link',function(){
  var $this = $(this);
  clearTimeout(menu_timeout);
  menu_timeout = setTimeout(function(){navLinkMouseLeave($this)}, 100);
});

$(document).on('mousenter','.mega',function(){
  clearTimeout(menu_timeout);
});

function megaMouseLeave() {
  if ($('.nav:hover').length == 0) {
    if (!$('.nav').hasClass('s_active')) {
      $('.header').removeClass('s_active');
      $('.mega').removeClass('s_active');
      $('.nav .nav-link').removeClass('s_hover');
      megaStaticRestore();
    }
  }
}

$(document).on('mouseleave','.mega',function(){
  clearTimeout(menu_timeout);
  menu_timeout = setTimeout(function(){megaMouseLeave()}, 350);
});

function navMouseLeave() {
  if ($('.mega:hover').length == 0) {
    $('.header').removeClass('s_active');
    $('.mega').removeClass('s_active');
    $('.nav .nav-link').removeClass('s_hover');
    megaStaticRestore();
  }
}

$(document).on('mouseleave','.nav',function(){
  clearTimeout(menu_timeout);
  menu_timeout = setTimeout(function(){navMouseLeave()}, 350);
});

$(document).on('click touchend','.mega',function(event){
  if (Is.touch) {
    event.stopPropagation();
  }
});

$(document).on('click touchend',function(event){
  if (Is.touch) {
    $('.mega').removeClass('s_active');
    $('.nav .nav-link').removeClass('s_hover');
    clearTimeout(menu_timeout);
    menu_timeout = setTimeout(function(){megaMouseLeave()}, 1);
  }
});

function megaStaticRestore() {

  if ($('.mega').hasClass('s_static')) {
    $('.mega-nav').removeClass('s_active');
    $('.mega-nav[data-id="' + $('.mega').attr('data-static') + '"]').addClass('s_active');
  }

}

// init
$(document).ready(function(){
  megaStaticRestore();
});


//* accordion =================================================== */

$(document).on('click','.accordion-head',function(){
  var $accordion = $(this).parents('.accordion');
  var $panel = $accordion.find('.accordion-body');
  if ($accordion.hasClass('s_active')) {
    $accordion.removeClass('s_active');
    $panel[0].style.maxHeight = 0;
  } else {
    // $('.accordion').removeClass('s_active');
    $accordion.addClass('s_active');
    $panel[0].style.maxHeight = $panel[0].scrollHeight + 'px';
  }
});


//* filter system =================================================== */

// if (typeof rootUrl === 'undefined') { var rootUrl = ''; }

var rootUrl = $('.filterbar').attr('data-rootUrl');
var currentUrl = $('.filterbar').attr('data-activeUrl');

window.addEventListener('popstate', function (event) {
  if (history.state && history.state.id === 'filter') {
    // Render new content for the hompage
    location.reload();

  }
}, false);

function filterInit() {
  // $('.filter-option[data-init="1"]').click();
  // if ($('.cards.l_masonry').length) {
  //   var macyInstance = Macy({
  //     container: '.cards.l_masonry',
  //     columns: 1,
  //     margin: {
  //       x: 0,
  //       y: 40,
  //     },
  //     mobileFirst: true,
  //     breakAt: {
  //       600: {
  //         columns: 2,
  //         margin: {
  //           x: 0,
  //           y: 40,
  //         },
  //       },
  //       960: {
  //         columns: 3,
  //         margin: {
  //           x: 0,
  //           y: 40,
  //         },
  //       },
  //     }
  //   });
  // }
}

function filterLinks() {

  // $('.filter').each(function(){

  //   var filterId = $(this).attr('data-id');

  //   $(this).find('a').each(function(){

  //     var slug = $(this).attr('data-slug');
  //     var url = rootUrl + '/' + filterId + '/'

  //   });

  // });

}

function filterLoadUrl(url) {

  $('.results').addClass('s_loading');

  currentUrl = url;

  $.get(url, function(data) {

    // push state
    var title = $(data).find('title').text();
    window.history.pushState({
      id: 'filter'
    }, title, url);

    $('.results').html($(data).find('.results').html());

    // console.log('results');
    // console.log($(data).find('.results').html());

    // filterInit();
    setTimeout(function(){
      // filterInit();
      $('.results').removeClass('s_loading');
    }, 1);

    // setTimeout(function(){
    //   filterInit();
    // }, 300);
  });

}

function filterSearch() {

  var params = new Object();
  var query = new Object();

  $('.filter').each(function(){

    var id = $(this).attr('data-id');

    if (id == 'keywords') {

      var keywords = $(this).find('input').val();
      query[id] = keywords;

    } else {

      var selected = $(this).find('.filter-option.s_active');
      var slug = selected.attr('data-slug');
      params[id] = slug;

    }


  });

  var url = rootUrl;
  var sep = '';
  for (var key in params) {
    if (params.hasOwnProperty(key)) {
      if (params[key] !== undefined) {
        url += sep + key;
        sep = '/';
        url += sep + params[key];
      }
    }
  }
  url += sep;

  // add query string
  var sep = '';
  if (Object.keys(query).length) {
    url += '?';
  }
  for (var key in query) {
    if (query.hasOwnProperty(key)) {
      if (query[key] !== undefined) {
        url += sep + key + '=' + encodeURIComponent(query[key]);
        sep = '&';
      }
    }
  }

  if (url !== currentUrl) {

    filterLoadUrl(url);

  }

  return false;

}

filterLinks();
filterInit();

$(document).on('click','[data-action="loadMore"]',function(){

  var url = $(this).attr('href');
  // console.log(url);
  filterLoadUrl(url);

  return false;

});


//* filter input =================================================== */

function delay(callback, ms) {
  var timer = 0;
  return function() {
    var context = this, args = arguments;
    clearTimeout(timer);
    timer = setTimeout(function () {
      callback.apply(context, args);
    }, ms || 0);
  };
}

$(document).on('change keyup','.filter-input',delay(function (e) {
  filterSearch();
}, 500));




//* filter =================================================== */

function filterSelectOpenClose($filterSelect) {

  // update tabindex
  if ($filterSelect.hasClass('s_active')) {
    $filterSelect.find('.filter-option').attr('tabindex', '');
  } else {
    $filterSelect.find('.filter-option').attr('tabindex', -1);
  }

}

function filterSelectClose($filterSelect) {

  // update tabindex
  $filterSelect.removeClass('s_active');
  $filterSelect.find('.filter-option').attr('tabindex', -1);

}

function filterAssignById(dataId, optionId) {
  var $filterSelect = $('.filter[data-id="' + dataId + '"]');
  $filterSelect.attr('data-val', optionId);
  $filterSelect.find('.filter-option').removeClass('s_active');
  $filterSelect.find('.filter-option[data-id="' + optionId + '"]').addClass('s_active');
  if (optionId !== '') {
    $filterSelect.addClass('s_on');
  } else {
    $filterSelect.removeClass('s_on');
  }
  var optionVal = $('.filter[data-id="' + dataId + '"] .filter-option[data-id="' + optionId + '"]').attr('data-val');
  $filterSelect.find('.filter-label span').text(optionVal);
  return true;
}

function filterAssignByVal(dataId, optionVal) {
  // console.log(dataId);
  // console.log(optionVal);
  var $filterSelect = $('.filter[data-id="' + dataId + '"]');
  $filterSelect.find('.filter-option').removeClass('s_active');
  var optionId = '';
  $filterSelect.find('.filter-option').each(function(){
    if ($(this).attr('data-val').toLowerCase().trim() == optionVal.toLowerCase().trim()) {
      optionId = $(this).attr('data-id');
      optionVal = $(this).attr('data-val');
    }
  });
  if (optionId.length) {
    $filterSelect.find('.filter-option[data-val="' + optionVal + '"]').addClass('s_active');
    if (optionId !== '') {
      $filterSelect.addClass('s_on');
    } else {
      $filterSelect.removeClass('s_on');
    }
    $filterSelect.attr('data-val', optionId);
    $filterSelect.find('.filter-label span').text(optionVal);
  }
  return true;
}

// toggle filter
$(document).on('click','.filter-toggle',function(){
  var $this = $(this);
  var $filter = $this.parents('.filter');
  $filter.toggleClass('s_show');
  return false;
});

// close filters, if click anywhere else
$(document).on('click',function(e){
  if(!$(e.target).hasClass('filter') ) {
    filterSelectClose($('.filter.s_active'));
  }
});

$(document).on('click','.filter',function(){

  // init
  var $this = $(this);
  $('.filter').not(this).removeClass('s_active');
  $this.toggleClass('s_active');
  filterSelectOpenClose($this);

  return false;
});

$(document).on('click','.filter-option',function(){

  // init
  var $this = $(this);
  var $filterSelect = $this.parents('.filter');
  var dataId = $filterSelect.attr('data-id');
  var optionId = $this.attr('data-id');

  // update filter and option
  filterAssignById(dataId, optionId);

  // close filter
  $filterSelect.removeClass('s_active');
  filterSelectOpenClose($filterSelect);

  // update results
  filterSearch();

  return false;
});

// filter button
$(document).on('click','.filter-btn',function(){
  var $this = $(this);
  var $filter = $this.parents('.filter');
  var action = $this.attr('data-action');

  if (action == 'clear') {
    $filter.find('.filter:not(.s_hidden)').each(function(){
      var defaultText = $(this).attr('data-default');
      $(this).attr('data-val', '');
      $(this).find('.filter-label span').text(defaultText);
      $(this).find('.filter-option').removeClass('s_active');
    });
    filterSearch();
  }

  if (action == 'go') {
    var functionName = $this.parents('.filterbar').attr('data-function');
    if (functionName) {
      window[functionName]();
    } else {
      filterSearch();
    }
  }

  return false;
});

// filter preselect
$(document).ready(function(){
  $('.filter a[data-preselect="1"]').click();
});


//* videos =================================================== */

var youtube = document.querySelectorAll(".video");

$(document).on('click','.video',function(){

  var videoId = $(this).attr('data-embed');

  if (videoId.length) {

    $(this).find('.video-play').remove();

    $(this).find('.video-overlay').html('').show();
    $('<iframe>', {
     src: 'https://www.youtube.com/embed/' + videoId + '?rel=0&showinfo=0&autoplay=1',
     id: 'myFrame',
     frameborder: 0,
     scrolling: 'no',
     allow: 'autoplay; encrypted-media;'
    }).appendTo($(this).find('.video-overlay'));

  } else {

    $(this).remove();

  }

});


//* animations =================================================== */

let observer = new IntersectionObserver(
(entries, observer) => {
  entries.forEach(entry => {
    // console.log(entry.intersectionRatio);
    if (entry.intersectionRatio > 0) {
      entry.target.classList.remove('s_animate');
    }
  });
},
{rootMargin: "0px 0px -100px 0px"});

document.querySelectorAll('.s_animate').forEach(el => { observer.observe(el) });


//* notice =================================================== */

$('.notice[data-type="cookie"]').each(function(){
  var cookieName = $(this).attr('data-id');
  if (!Cookie.read(cookieName)) {
    $('.notice[data-id="' + cookieName + '"]').addClass('s_active');
  }
});

$(document).on('click','.notice [data-notice-close]',function(){
  var $this = $(this);
  var $notice = $this.parents('.notice');
  $notice.removeClass('s_active');

  if ($notice.attr('data-type') == 'cookie') {
    var cookieName = $notice.attr('data-id');
    var expiresDays = $notice.attr('data-expires') ? parseFloat($notice.attr('data-expires')) : 1;
    Cookie.create(cookieName, 1, expiresDays);
  }

  return false;
});


//* offset =================================================== */

function getElementOffset(el) {
  var rect = el.getBoundingClientRect(),
  scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
  scrollTop = window.pageYOffset || document.documentElement.scrollTop;
  return { top: rect.top + scrollTop, left: rect.left + scrollLeft }
}



//* site promos =================================================== */

function sitePromoScroll() {

  var windowHeight = window.innerHeight;
  var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
  var scrollBottom = scrollTop + windowHeight;
  var scrollMiddle = scrollTop + windowHeight / 2;

  if (document.querySelector('.sitepromo-screeninner')) {

    var elTop = getElementOffset(document.querySelector('.sitepromo-screeninner')).top;
    var elHeight = document.querySelector('.sitepromo-screeninner').offsetHeight;
    var elScrollHeight = document.querySelector('.sitepromo-screeninner').scrollHeight;
    var elBottom = elTop + elHeight;

    if (scrollBottom > elTop && scrollTop < elBottom) {

      var screenPercent = (scrollMiddle - 100 - elTop) / windowHeight * 100;
      var elMax = elScrollHeight - elHeight;
      var elRange = 100;
      if (elRange > elMax) {
        elRange = elMax;
      }
      // var elOffset = elRange / 100 * screenPercent - elRange / 2;
      var elOffset = (elRange / 100 * (screenPercent)) * -1;
      // console.log(elOffset);
      if (elOffset > 0) {
        elOffset = 0
      }
      // elOffset = elOffset * -1;
      // console.log(elOffset);

      document.querySelector('.sitepromo-screeninner').style.transform = 'translateY(' + elOffset + 'px)';

    }

  }


}

window.addEventListener('scroll', sitePromoScroll);
sitePromoScroll();


//* map =================================================== */

$(document).on('click','.novamaparea',function(){

  var locationCode = $(this).attr('data-id');

  var containerWidth = $('.novamapsvg').outerWidth();
  var containerHeight = $('.novamapsvg').outerHeight();

  var mapWidth = $('.novamapsvg')[0].getBBox().width;
  var mapHeight = $('.novamapsvg')[0].getBBox().height;

  var areaX = $(this)[0].getBBox().x;
  var areaY = $(this)[0].getBBox().y;
  var areaWidth = $(this)[0].getBBox().width;
  var areaHeight = $(this)[0].getBBox().height;

  var leftNew = areaX / mapWidth * containerWidth + areaWidth / 2 / mapWidth * containerWidth;
  var topNew = areaY / mapHeight * containerHeight;

  if (locationCode == 'au' || locationCode == 'nz') {
    $('.novamapinfo').addClass('s_flipped');
  } else {
    $('.novamapinfo').removeClass('s_flipped');
    topNew += areaHeight / mapHeight * containerHeight;
  }

  if ((leftNew + $('.novamapinfo').outerWidth() / 2) > $(window).width()) {
    leftNew -= (leftNew + $('.novamapinfo').outerWidth() / 2) - $(window).width() + 40;
  }

  $('.novamapinfo').addClass('s_active')
  $('.novamapinfo').css('left', leftNew);
  $('.novamapinfo').css('top', topNew);
  $('.novamapinfo').attr('data-show', locationCode);

  $('.novamapinfo-head strong').html(mapLocations[locationCode].title);
  $('.novamapinfo-head span').html(mapLocations[locationCode].subTitle);
  $('.novamapinfo-body').html(mapLocations[locationCode].content);

});

$(document).on('mouseover','.novamaparea-hidden',function(){

  var locationCode = $(this).attr('data-id');
  $('.novamaparea[data-id="' + locationCode + '"]').addClass('s_hover');

});

$(document).on('mouseout','.novamaparea-hidden',function(){

  $('.novamaparea').removeClass('s_hover');

});


//* references =================================================== */

$(document).on('click','.reference-row',function(){
  $(this).parents('.reference').toggleClass('s_active');
});


//* molteno hotspot2s =================================================== */

// var hotspotCurrent = 0;
// var hotspotTotal = 0;
var hotspotInterval = false;
var hotspots = {};

function hotspotInit(id) {
  var $hotspots = $('.hotspots[data-id="' + id + '"]');
  hotspots[id] = {
    current: 0,
    total: $hotspots.find('.hotspot').length,
    interval: false,
    highlight: 0,
    highlightInterval: false,
  }
  clearInterval(hotspots[id].interval);
  hotspots[id].interval = setInterval(hotspotNext, 5000, id);
  hotspotActivate(id);
  
  clearInterval(hotspots[id].highlightInterval);
  hotspots[id].highlightInterval = setInterval(hotspotHighlight, 500, id);
}

function hotspotStart(id) {
  clearInterval(hotspots[id].interval);
  hotspots[id].interval = setInterval(hotspotNext(id), 5000);
}

function hotspotActivate(id) {
  
  var $hotspots = $('.hotspots[data-id="' + id + '"]');
  
  // console.log( hotspots[id].current);

  $hotspots.find('.hotspot').removeClass('s_active');
  $hotspots.find('.hotspot').eq(hotspots[id].current - 1).addClass('s_active');

  $hotspots.find('.hotspotinfo-content').html($hotspots.find('.hotspot').eq(hotspots[id].current - 1).find('.hotspot-content').html());
  $hotspots.find('.hotspotinfo').addClass('s_active');
  $hotspots.find('.hotspotinfo').css('top', $('.hotspot').eq(hotspots[id].current).position().top);

}

function hotspotNext(id) {
  
  hotspots[id].current ++;
  if (hotspots[id].current >= hotspots[id].total) {
    hotspots[id].current = 0;
  }

  hotspotActivate(id);

}

function hotspotHighlight(id) {
  
  // hotspots[id].highlight ++;
  // if (hotspots[id].highlight >= hotspots[id].total + 5) {
  //   hotspots[id].highlight = 0;
  // }
  
  // if (hotspots[id].highlight <= hotspots[id].total) {
  //   var $hotspots = $('.hotspots[data-id="' + id + '"]');
  //   $hotspots.find('.hotspot').eq(hotspots[id].highlight - 1).removeClass('s_highlight');
  //   setTimeout(() => {
  //     $hotspots.find('.hotspot').eq(hotspots[id].highlight - 1).addClass('s_highlight');
  //   }, 100);

  // }
  
}

$(function(){
  
  $('.hotspots').each(function() {
    var id = $(this).attr('data-id');
    hotspotInit(id);
  });

});

$(document).on('click','.hotspot',function(){
  
  var id = $(this).parents('.hotspots').first().attr('data-id');
  var $hotspots = $('.hotspots[data-id="' + id + '"]');
  
  // console.log(id);
  // console.log($hotspots);
  
  $hotspots.find('.hotspot').removeClass('s_active');
  $(this).addClass('s_active');
  hotspots[id].current = $(this).index();
  hotspotActivate(id);
  clearInterval(hotspots[id].interval);
  setTimeout(hotspotStart(id), 10000);
  return false;
  
});

$(document).on('click','.hotspotinfo-close',function(){
  
  var id = $(this).parents('.hotspots').first().attr('data-id');
  var $hotspots = $('.hotspots[data-id="' + id + '"]');
  // console.log($hotspots);
  
  clearInterval(hotspots[id].interval);
  $hotspots.find('.hotspotinfo').removeClass('s_active');
  return false;
  
});


//* hero slider =================================================== */
  
$('.hero-slider').each(function(){
  
  var $this = $(this);
  var heroCurrent = 0;
  var heroInterval = setInterval(function(){
    heroCurrent++;
    var heroImages = $this.find('.hero-image').length;
    if (heroCurrent >= heroImages) heroCurrent = 0;
    $this.find('.hero-image').removeClass('s_active');
    $this.find('.hero-image:eq(' + heroCurrent + ')').addClass('s_active');
  }, 5000);
  
  $('.hero-image:eq(0)').addClass('s_active');
  
});